import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=0cfaa94a&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=0cfaa94a&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfaa94a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cfaa94a')) {
      api.createRecord('0cfaa94a', component.options)
    } else {
      api.reload('0cfaa94a', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=0cfaa94a&scoped=true", function () {
      api.rerender('0cfaa94a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/flowinstances/detail.vue"
export default component.exports